<template>
  <div>
    <!-- 我的订单 -->
    <div class="all-center-box">
      <div class="user-page-box w-100">
        <div class="bg"></div>
        <div class="w-1500">
          <div class="user-top-box w-100">
            <div class="pull-left">个人中心</div>
            <div class="pull-right">
              <div class="f-l"><router-link to="/">首页</router-link></div>
              <div class="f-r">
                您当前的位置：<router-link to="/">首页</router-link> >
                <router-link to="/meOrder">个人中心</router-link>
              </div>
            </div>
          </div>
          <div class="user-lower-box w-100 cb">
            <div class="user-left">
              <ul>
                <template v-for="(item, index) in routerLinks">
                  <router-link :to="item.url"
                    ><li
                      :class="{ active: routerIndex == index || item.url === currentRoute }"
                      @click="change(index)"
                    >
                      <a href="" :class="item.icon">{{ item.pageName }}</a>
                    </li></router-link
                  >
                </template>
                <!-- <router-link  to="/meMsg"><li><a href="" class="icon2">我的消息<i>2</i></a></li></router-link>
								<router-link  to="/meInquiry"><li><a href="" class="icon3">我的询价</a></li></router-link>
								<router-link  to="/meCart"><li><a href="" class="icon4">我的购物车</a></li></router-link>
								<router-link  to="/meGallery"><li><a href="" class="icon5">我的图库</a></li></router-link>
								<router-link  to="/downloadRecord"><li><a href="" class="icon6">下载记录</a></li></router-link>
								<router-link  to="/meCollection"><li><a href="" class="icon7">我的收藏</a></li></router-link>
								<router-link  to="/invoiceManageList"><li><a href="" class="icon8">发票管理</a></li></router-link>
								<router-link  to="/afterSaleService"><li><a href="" class="icon9">售后服务</a></li></router-link>
								<router-link  to="/receivingAddress"><li><a href="" class="icon10">收货地址</a></li></router-link>
								<router-link  to="/accountSettings"><li><a href="" class="icon11">账号设置</a></li></router-link> -->
              </ul>
            </div>
            <div class="user-right">
              <router-view @change_bread="change($event)"></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      routerIndex: 0,
      routerLinks: [
        { url: '/meOrder', icon: 'icon1', pageName: '我的订单' },
        { url: '/meMsg', icon: 'icon2', pageName: '我的消息' },
        { url: '/meInquiry', icon: 'icon3', pageName: '我的询价' },
        { url: '/meCart', icon: 'icon4', pageName: '我的购物车' },
        // {url: '/meGallery', icon: 'icon5', pageName: '我的图库'},
        // { url: '/downloadRecord', icon: 'icon6', pageName: '下载记录' },
        { url: '/meCollection', icon: 'icon7', pageName: '我的收藏' },
        // { url: '/invoiceManageList', icon: 'icon8', pageName: '发票管理' },
        // { url: '/afterSaleService', icon: 'icon9', pageName: '售后服务' },
        // { url: '/receivingAddress', icon: 'icon10', pageName: '收货地址' },
        { url: '/accountSettings', icon: 'icon11', pageName: '账号设置' }
      ]
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path
    }
  },
  mounted() {
    console.log('this.$route.path', this.$route.path)
  },
  methods: {
    change (index) {
      this.routerIndex = index;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/me.vue